define('util/queryParamParser',[], function () {
    'use strict';

    function buildQueryRegex (parameter) {
        return new RegExp("^(?:.*[&\\?]" + encodeURI(parameter).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i");
    }

    var queryParser = {
        //Query parameter extraction adapted from: https://developer.mozilla.org/en-US/docs/Web/API/Window.location
        getParameterValue: function (parameter) {
            return decodeURI(window.location.search.replace(buildQueryRegex(parameter), "$1"));
        },

        // added ability to parse params passed on the hash as well
        getHashParameterValue: function (parameter) {
            return decodeURI(window.location.hash.replace(buildQueryRegex(parameter), "$1"));
        }
    };

    return queryParser;
});

